import React, { useEffect, useState } from "react";
import useRequest from "../../../hooks/useRequest";
import { useTranslation } from "react-i18next";
import CustomDataTable from "../../../components/CustomDataTable";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { AlertService } from "../../../services/Alert";
import { BlacklistWordsConfigService } from "../../../services/BlacklistWordsConfigService";
import AddWordModal from "./AddWordModal";
import { DateUtil } from "../../../utils/date";

export default function BlacklistWordsPartial() {
  const { t } = useTranslation();
  const { call, isRequesting } = useRequest();
  const columns = [
    {
      name: t("config.blacklist.word"),
      sortable: true,
      selector: (row) => row.word,
    },
    {
      name: t("config.blacklist.updated_at"),
      sortable: true,
      selector: (row) => DateUtil.format(row.updated_at)
    },
    {
      name: t("config.blacklist.actions"),
      sortable: false,
      center: true,
      cell: (row) => {
        return (
          <div className="btn-group" role="group">
            <button
              className="btn btn-white btn-sm"
              onClick={() => setShowModal({ show: true, data: row })}
            >
              {t("btn-edit")}
            </button>
            <div className="btn-group">
              <button
                type="button"
                className="btn btn-white btn-icon btn-sm dropdown-toggle dropdown-toggle-empty"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              ></button>
              <div className="dropdown-menu dropdown-menu-end mt-1">
                <button
                  className="dropdown-item"
                  onClick={() => deleteWord(row)}
                >
                  {t("btn-delete")}
                </button>
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  const { account } = useCurrentAccount();
  const [rows, setRows] = useState([]);

  const [showModal, setShowModal] = useState({
    show: false,
    data: null,
  });

  const handleShowModal = async (refresh: boolean) => {
    if (refresh) {
      await getAll();
    }
    setShowModal({ show: false, data: null });
  };

  const getAll = async () => {
    const { data } = await call(() => BlacklistWordsConfigService.getAll(account.id));
    setRows(data);
  };

  const deleteWord = async (data) => {
    const isConfirmed = await AlertService.warning(
      "Borrar palabra",
      "¿Estás seguro de querer borrar esta palabra? Esta acción no se puede deshacer",
      async () => {
        try {
          await BlacklistWordsConfigService.deleteWord(data.id);
          await getAll();
        } catch (error) {
          console.error(error);
          AlertService.error(
            "¡Error!",
            "Ocurrió un error al borrar la palabra, intenta nuevamente"
          );
        }
      }
    );
    if (isConfirmed) {
      AlertService.success("¡Éxito!", "Se borró la palabra correctamente");
    }
  };

  
  useEffect(() => {
    getAll();
  }, []);

  return (
    <>
      <div className="card">
        <div className="card-header d-flex align-items-center">
          <div className="me-3 flex-grow-1">
            <h2 className="card-title h4">
              {t("config.blacklist.blacklist-title")}
            </h2>
            <p className="small mb-0">{t("config.blacklist.blacklist-text")}</p>
          </div>

          <div className="col-sm-auto">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => setShowModal({ show: true, data: null })}
            >
              <i className="bi-plus-lg me-1"></i>
              {t("config.blacklist.add-btn")}
            </button>
          </div>
        </div>
        <div className="card-body">
          <CustomDataTable
            columns={columns}
            data={rows}
            hideAccountsFilter
            isLoading={isRequesting}
            filter={(row, term) => {
              if (!term) return true;
              return (
                `${row.word}`.match(new RegExp(`${term}`, "i")) 
              );
            }}
          />
        </div>
      </div>
      <AddWordModal
        show={showModal.show}
        onRequestClose={(refresh) => handleShowModal(refresh)}
        payload={showModal.data}
      />
    </>
  );
}
